
'use strict';

//Require Modules
var $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  config = require('../../js/config'),
  mediator = require('../../js/mediator'),
  ModalView = require('../../js/components/ModalView'),
  LoaderView = require('../Loader/LoaderView'),
  LoginView = require('../../js/session/views/LoginView'),
  designCenter = require('./design-center'),
  session = require('../../js/session/index'),
  envisionTooltipTemplate = require('./templates/envision-modal.hbs'),
  envisionConfirmTemplate = require('./templates/envision-confirm-modal.hbs'),

  EVENTS = {
    cancelled: 'cancelled',
    succeeded: 'succeeded',
    confirming: 'confirming',
    confirmed: 'confirmed',
    failed: 'failed'
  },
  STATE_CLASS = {
    options: 'ProjectEnvisionDesignModal--options',
    loggedOut: 'ProjectEnvisionDesignModal--loggedOut',
    loading: 'ProjectEnvisionDesignModal--loading'
  };

Backbone.$ = $;

var ProjectEnvisionDesignModalView = Backbone.View.extend({

  initialize: function(options) {
    options = options || {};
    this.hasDesign = options.hasDesign;
    this.projectId = options.projectId;
    this.pubId = options.pubId;
    this.uri = options.uri;
    this.reloadOnRename = options.reloadOnRename === false ? false : true;

    this.updateUiState = _.debounce(this.updateUiState, 20);

    this.loaderView = new LoaderView();
    this.loginView = new LoginView();
    this.confirmModal = new ModalView({ template: envisionConfirmTemplate });
    this.listenTo(this.confirmModal, 'confirm', this.onConfirmed);
    this.listenTo(this.confirmModal, 'cancel', this.onCancel);
    this.listenTo(designCenter.projectsController.model, 'change', this.updateUiState, this);
    this.listenTo(session.sessionController.model, 'change', this.updateUiState, this);
    mediator.on(config.events.designCenter.projectDesignReplaced, this.renameProjectSucceeded, this);
    mediator.on(config.events.designCenter.replaceDesignFailed, this.renameProjectFailed, this);
  },

  tagName: 'section',
  className: 'ProjectEnvisionDesignModal',
  isReplacingProject: false,
  isReloading: false,
  hasReplaceFailed: false,
  lastServerError: null,

  events: {
    'click .create': 'onCreate',
    'click .replace': 'onReplace',
    'click .cancel': 'onCancel'
  },

  render: function() {
    this.$el.html(envisionTooltipTemplate({
      hasDesign: this.hasDesign,
      pubId: this.pubId,
      uri: this.uri
    }))
      .append(this.loaderView.el)
      .append(this.loginView.el);
    this.$errorMessage = this.$('.Modal-errorMessage');
    this.loaderView.render();
    this.loginView.render();
    this.updateUiState();
    return this;
  },


  onCreate: function() {
    this.onConfirmed();
  },

  onReplace: function() {
    this.trigger(EVENTS.confirming);
    this.confirmOpen = true;
    this.confirmModal.open();
  },

  onConfirmed: function() {
    this.isReplacingProject = true;
    this.confirmOpen = false;
    this.confirmModal.close();
    this.updateUiState();
    mediator.trigger(config.events.designCenter.replaceDesign, this.projectId, this.pubId);
    this.trigger(EVENTS.confirmed);
  },

  onCancel: function(e) {
    if (e && e.preventDefault) e.preventDefault();
    this.resetView();
    this.trigger(EVENTS.cancelled);
  },

  resetView: function() {
    this.removeError();
    this.confirmOpen = false;
    this.confirmModal.close();
    this.isReplacingProject = false;
    this.isReloading = false;
    this.hasReplaceFailed = false;
    this.lastServerError = null;
  },

  setError: function(errorText) {
    this.$errorMessage.text(errorText).show();
  },

  removeError: function() {
    this.$errorMessage.text('').hide();
  },

  updateUiState: function() {
    if (session.sessionController.isLoggedIn() === false) {
      this.showLoggedOutStateUi();
    } else {
      if (this.isReplacingProject || this.isReloading || designCenter.projectsController.isReplacingDesign(this.projectId)) {
        this.showLoadingIndicatorUi();
      } else {
        this.showFormUi();
      }
    }
  },

  setStateClass: function(stateClass) {
    this.$el
      .removeClass(STATE_CLASS.options)
      .removeClass(STATE_CLASS.loggedOut)
      .removeClass(STATE_CLASS.loading);
    this.$el.addClass(stateClass);
  },

  showLoggedOutStateUi: function() {
    this.setStateClass(STATE_CLASS.loggedOut);
  },

  showLoadingIndicatorUi: function() {
    this.setStateClass(STATE_CLASS.loading);
    this.isReplacingProject = true;
  },

  showFormUi: function() {
    this.setStateClass(STATE_CLASS.options);
    if (this.hasReplaceFailed) {
      if (this.lastServerError && this.lastServerError.get('title')) {
        this.$errorMessage.text(this.lastServerError.get('title'));
      }
    }
  },

  renameProjectSucceeded: function(projectId, pubId) {
    if (this.isReplacingProject && projectId === this.projectId && pubId === this.pubId) {
      this.isReplacingProject = false;
      this.isReloading = true;
      this.hasReplaceFailed = false;
      this.lastServerError = null;
      if (this.reloadOnRename) {
        mediator.trigger(config.events.requestPageReload);
      }
    }
    this.updateUiState();
  },

  renameProjectFailed: function(projectId, pubId, err) {
    if (this.isReplacingProject && projectId === this.projectId) {
      this.isReplacingProject = false;
      this.hasReplaceFailed = true;
      this.lastServerError = err;
    }
    this.updateUiState();
  }

}, {
  EVENTS: EVENTS
});

module.exports = ProjectEnvisionDesignModalView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/ProjectEnvisionDesignModalView.js